import { createSelector } from 'reselect';

import { membershipsSelector } from './membershipsSelector';
import { companyLinksSelector } from './companyLinksSelector';
import { resourcesLinksSelector } from './resourcesLinksSelector';
import { appLinksSelector } from './appLinksSelector';
import { legalLinksSelector } from './legalLinksSelector';
import { mainSectionsSelector } from './mainSectionsSelector';
import { servicesSelector } from './servicesSelector';
import { loggedInSelector } from './loggedInSelector';

/*
 *  PUT (re)SELECTORS TOGETHER
 */
const selectFooterLinks = createSelector(
  [
    membershipsSelector,
    companyLinksSelector,
    resourcesLinksSelector,
    appLinksSelector,
    legalLinksSelector,
    mainSectionsSelector,
    servicesSelector,
    loggedInSelector,
  ],
  (
    memberships,
    companyLinks,
    resourcesLinks,
    appLinks,
    legalLinks,
    mainSectionsLinks,
    servicesLinks,
    loggedIn
  ) => ({
    links: {
      memberships,
      companyLinks,
      resourcesLinks,
      appLinks,
      legalLinks,
      mainSectionsLinks,
      servicesLinks,
    },
    loggedIn,
  })
);

export { selectFooterLinks };
